import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, MapPin, LogIn } from 'lucide-react';

export default function PrivatePreviewPage({ isLoggedIn = false }) {
  return (
    <div className="min-h-screen bg-slate-950 flex flex-col items-center justify-center px-4">
      <div className="max-w-lg w-full text-center">
        <div className="flex items-center justify-center gap-2 mb-8">
          <Shield className="w-6 h-6 text-signal-blue" />
          <span className="font-heading text-xl font-bold text-white tracking-widest uppercase">
            TLA Housing Europe
          </span>
        </div>

        <div className="bg-slate-900 border border-slate-800 rounded-2xl p-10 shadow-2xl">
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-signal-blue/10 border border-signal-blue/20 rounded-full mb-6">
            <span className="w-2 h-2 rounded-full bg-signal-blue animate-pulse" />
            <span className="text-signal-blue text-xs font-mono uppercase tracking-widest">
              Private Preview
            </span>
          </div>

          <h1 className="font-heading text-3xl sm:text-4xl font-bold text-white mb-4 leading-tight">
            CURRENTLY IN PRIVATE PREVIEW
          </h1>

          <p className="text-slate-400 text-base leading-relaxed mb-6">
            TLA Housing Europe is finalizing verified housing, relocation tools,
            and owner onboarding for military and government personnel PCSing
            to Germany and Europe.
          </p>

          <div className="border-t border-slate-800 pt-6">
            {isLoggedIn ? (
              <p className="text-slate-500 text-sm leading-relaxed">
                This private preview is currently limited to administrators.
                Contact the project owner if you need access.
              </p>
            ) : (
              <div className="space-y-3">
                <p className="text-slate-500 text-sm leading-relaxed">
                  If you are part of the test group, use your Vercel preview link or
                  contact the project owner directly.
                </p>
                <Link
                  to="/login"
                  className="inline-flex items-center gap-2 px-4 py-2 bg-signal-blue hover:bg-signal-blue-hover text-white text-sm font-medium rounded-lg transition-colors"
                >
                  <LogIn className="w-4 h-4" />
                  Admin sign in
                </Link>
              </div>
            )}
          </div>
        </div>

        <div className="flex items-center justify-center gap-2 mt-8 text-slate-600 text-xs">
          <MapPin className="w-3 h-3" />
          <span>Germany-first. Europe-ready.</span>
        </div>
      </div>
    </div>
  );
}
